import { render, staticRenderFns } from "./CreateReceiveForm.vue?vue&type=template&id=c0a0a36a"
import script from "./CreateReceiveForm.vue?vue&type=script&lang=js"
export * from "./CreateReceiveForm.vue?vue&type=script&lang=js"
import style0 from "./CreateReceiveForm.vue?vue&type=style&index=0&id=c0a0a36a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports